"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var map_cursor_to_max_1 = require("map-cursor-to-max");
exports.useCursor = function (_a) {
    var max = _a.max, _b = _a.initialCursor, initialCursor = _b === void 0 ? 0 : _b;
    var _c = react_1.useState(initialCursor), cursor = _c[0], setCursor = _c[1];
    var handlePrev = react_1.useCallback(function () { return setCursor(function (n) { return n - 1; }); }, []);
    var handleNext = react_1.useCallback(function () { return setCursor(function (n) { return n + 1; }); }, []);
    var handleCursor = react_1.useCallback(function (nextCursor) { return setCursor(nextCursor); }, []);
    var index = react_1.useMemo(function () { return map_cursor_to_max_1.mapCursorToMax(cursor, max); }, [cursor, max]);
    return {
        handlePrev: handlePrev,
        handleNext: handleNext,
        setCursor: handleCursor,
        cursor: cursor,
        index: index
    };
};
